import {File, FILES_API_PATH, Invoice, InvoiceApi, PaymentMode, SupplierInvoice} from "@betrue/shared/interfaces";
import {useState} from "react";
import {gql, useLazyQuery, useMutation} from "@apollo/client";
import {useResult} from "./results";
import {CORE_FILE_FIELDS} from "./file.service";
import {BASE_ENTITY_FIELDS} from "./base-fields";
import {CONFIG} from "@betrue/ui";

export const CORE_INVOICE_FIELDS = gql`
  ${CORE_FILE_FIELDS}
  fragment CoreInvoiceFields on SupplierInvoiceModel{
    ${BASE_ENTITY_FIELDS}
    amountTotal
    amountUntaxed
    invoiceDate
    paymentState
    state
    reference
    file {
      ...CoreFileField
    }
    submitter {
      ${BASE_ENTITY_FIELDS}
      stripeAccountId
      firstName
      lastName
    }
  }
`


const CREATE_SUPPLIER_INVOICE = gql`
  ${CORE_INVOICE_FIELDS}
  mutation createSupplierInvoice($supplierInvoice: SupplierInvoiceModelInput!) {
    createSupplierInvoice(supplierInvoice: $supplierInvoice) {
      ...CoreInvoiceFields
    }
  }
`

const GET_SUPPLIER_INVOICES =
gql`
  ${CORE_INVOICE_FIELDS}
  query supplierInvoices($supplierId: String!){
    supplierInvoices(supplierId: $supplierId){
      ...CoreInvoiceFields
    }
  }
`

const DELETE_SUPPLIER_INVOICE =
gql`
  ${CORE_INVOICE_FIELDS}
  query deleteSupplierInvoice($id: String!){
    deleteSupplierInvoice(id: $id){
      ...CoreInvoiceFields
    }
  }

`

const PAY_SUPPLIER_INVOICE =
gql`
  ${CORE_INVOICE_FIELDS}
  mutation paySupplierInvoice($id: String!, $paymentMode:  PaymentMode!){
    paySupplierInvoice(id: $id, paymentMode: $paymentMode ){
      ...CoreInvoiceFields
    }
  }

`

const FIND_ALL =
gql`
  ${CORE_INVOICE_FIELDS}
  query findAll{
    findAllInvoices{
      ...CoreInvoiceFields
    }
  }

`

export const useInvoice = <T = Invoice | Invoice[]>(): [T, InvoiceApi] => {
  const [result, setResult] = useState<T>();
  const createSupplierInvoice = useResult(useMutation(CREATE_SUPPLIER_INVOICE), setResult)
  const supplierInvoices = useResult(useLazyQuery(GET_SUPPLIER_INVOICES, {fetchPolicy: 'cache-and-network'}), setResult)
  const deleteSupplierInvoice = useResult(useLazyQuery(DELETE_SUPPLIER_INVOICE, {fetchPolicy: 'cache-and-network'}), setResult)
  const paySupplierInvoice = useResult(useMutation(PAY_SUPPLIER_INVOICE), setResult)
  const findAll = useResult(useLazyQuery(FIND_ALL, {fetchPolicy: 'cache-and-network'}), setResult)

  return [
    result,
    {
      findAllInvoices() {
        findAll({})
      },
      paySupplierInvoice(id: string, mode: PaymentMode) {
        paySupplierInvoice({
          variables: {
            id: id,
            paymentMode: mode
          }
        })
      },
      deleteSupplierInvoice(id: string) {
        deleteSupplierInvoice({
            variables: {
              id: id
            }
          }
        )

      },
      createSupplierInvoice(supplierInvoice: SupplierInvoice) {
        createSupplierInvoice({
          variables: {
            supplierInvoice: {...supplierInvoice}
          }
        })
      },
      supplierInvoices(supplierId: string) {
        supplierInvoices({
          variables: {
            supplierId: supplierId
          }
        })
      }
    }]
}

export const fileUrl = (file: File) => {
  return `${CONFIG.backend.url}/${FILES_API_PATH}/${file.filename}?id=${file.id}`
}
